import { supabase } from './supabase';

class FotoVisitaService {
  private readonly BUCKET_NAME = 'fotos-visitas';

  // Upload da selfie do visitante (capturada pela câmera ao solicitar a visita)
  async uploadFotoVisitante(file: File): Promise<{ url?: string; error?: string }> {
    try {
      if (!file) {
        return { error: 'Nenhuma foto capturada' };
      }

      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        return { error: 'A foto deve ter no máximo 5MB' };
      }

      const fileName = `visitante_${Date.now()}_${Math.random().toString(36).slice(2, 8)}.jpg`;

      const { error: uploadError } = await supabase.storage
        .from(this.BUCKET_NAME)
        .upload(fileName, file, {
          cacheControl: '3600',
          upsert: true,
          contentType: 'image/jpeg'
        });

      if (uploadError) {
        console.error('Erro ao fazer upload da selfie:', uploadError);
        return { error: `Erro ao fazer upload da foto: ${uploadError.message}` };
      }

      const { data: publicUrlData } = supabase.storage
        .from(this.BUCKET_NAME)
        .getPublicUrl(fileName);

      return { url: publicUrlData.publicUrl };
    } catch (error) {
      console.error('Erro no upload da selfie:', error);
      return { error: `Erro ao fazer upload da foto: ${error}` };
    }
  }
}

export default new FotoVisitaService();
